import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { CATEGORIES } from "@/mocks/categories";

export default function CategoryDropdown() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState<string | null>(null);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const onClick = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  return (
    <div className="relative w-full max-w-md" ref={ref}>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="w-full flex items-center justify-between gap-3 px-4 py-3 rounded-lg bg-background-50 border border-background-200 text-foreground-900 text-sm font-medium hover:border-primary-300 transition-colors"
      >
        <span className="flex items-center gap-2 whitespace-nowrap">
          <i className="ri-function-line text-base text-primary-500" />
          {selected ? t(selected) : t("dropdown.placeholder")}
        </span>
        <i
          className={`ri-arrow-down-s-line text-base text-foreground-500 transition-transform ${
            open ? "rotate-180" : ""
          }`}
        />
      </button>

      {open && (
        <div className="absolute left-0 right-0 mt-2 max-h-80 overflow-y-auto rounded-lg border border-background-200 bg-background-50 shadow-sm py-1 z-40">
          {CATEGORIES.map((cat) => (
            <a
              key={cat.id}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              onClick={() => {
                setSelected(cat.labelKey);
                setOpen(false);
              }}
              className="flex items-center gap-3 px-4 py-2.5 text-sm text-foreground-800 whitespace-nowrap hover:bg-background-100 transition-colors"
            >
              <span className="w-6 h-6 flex items-center justify-center rounded-md bg-secondary-100 text-secondary-700">
                <i className={`${cat.icon} text-sm`} />
              </span>
              {t(cat.labelKey)}
            </a>
          ))}
        </div>
      )}
    </div>
  );
}